
const isInteger = ( value ) => {
  return /^-?\d+$/.test(value);
}

const addSeatVisibility = ( teamData ) => {
  if( ! teamData || !teamData.product || !teamData.subscription ) return false

  const isProductLinked = teamData.product && teamData.product.length !== 0
  const isSubscriptionNotActive = ['expired', 'cancelled', 'trash'].includes(teamData.subscription.subscription_status)
  if( isSubscriptionNotActive || ! isProductLinked ) return false

  const isUserTeamOwner = teamData.is_user_team_owner
  const isProductWithoutMemberLimit = teamData.product.teams_max_member_count !== '' || teamData.product.teams_pricing !== 'per_team'
  return ( isUserTeamOwner && isProductWithoutMemberLimit )
}

export {
  isInteger,
  addSeatVisibility
}
